import React from "react";
import { Lightbulb, AlertTriangle, Info } from "lucide-react";

interface CalloutProps {
  type: "tip" | "warning" | "info";
  /**
   * Whether to render the leading icon. Defaults to `true` so existing usages are unaffected.
   */
  showIcon?: boolean;
  children: React.ReactNode;
}

const baseClasses = "callout p-4 rounded-md border flex items-start mb-6";
const typeClasses = {
  tip: "bg-blue-50 border-blue-200 text-blue-800 dark:bg-blue-900/20 dark:border-blue-700 dark:text-blue-100",
  warning:
    "bg-yellow-50 border-yellow-200 text-yellow-800 dark:bg-yellow-900/20 dark:border-yellow-700 dark:text-yellow-100",
  info: "bg-sky-50 border-sky-200 text-sky-800 dark:bg-sky-900/20 dark:border-sky-700 dark:text-sky-100",
};

export const Callout: React.FC<CalloutProps> = ({
  type,
  showIcon = true,
  children,
}) => {
  const Icon =
    type === "tip" ? Lightbulb : type === "warning" ? AlertTriangle : Info;

  const iconColorClass =
    type === "tip"
      ? "text-blue-500 dark:text-blue-400"
      : type === "warning"
      ? "text-yellow-500 dark:text-yellow-400"
      : "text-sky-500 dark:text-sky-400";

  return (
    <div className={`${baseClasses} ${typeClasses[type]}`}>
      {showIcon && (
        <Icon className={`w-5 h-5 mr-2 ${iconColorClass}`} strokeWidth={2.5} />
      )}
      <div className="flex-1">{children}</div>
    </div>
  );
};
